export enum DelegationStatusEnum {
  Draft = 1,
  PendingApproval = 2,
  Accepted = 3,
  Rejected = 4,
  SettlementPendingApproval = 5,
  SentForSettlement = 9,
  PendingApprovalAccounting = 10,
  ReturnedFromAccounting = 12,
  ReturnedFromSupervisor = 13
}
